module.exports = __webpack_public_path__ + "img/Juego niños.bec508f8.png";